import {
	Component,
	OnInit,
	ViewEncapsulation
} from '@angular/core';

import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { OSM, Vector as VectorSource } from 'ol/source.js';
import { Fill, Style, Stroke } from 'ol/style.js';
import { fromLonLat } from 'ol/proj';


import 'rxjs/add/operator/debounceTime';
import { SpeakerService } from '../speaker.service';


declare let d3: any;

@Component({
	selector: 'map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class MapComponent implements OnInit {
	
	stats: any;
	choropleth1994:any;
	choropleth2014:any;
	regionMappings = {
		"London": [
			{"id":	1	},
			{"id":	5	},
			{"id":	8	},
			{"id":	11	},
			{"id":	14	},
			{"id":	17	},
			{"id":	25	},
			{"id":	28	},
			{"id":	31	},
			{"id":	32	},
			{"id":	34	},
			{"id":	36	},
			{"id":	37	},
			{"id":	39	},
			{"id":	42	},
			{"id":	43	},
			{"id":	45	},
			{"id":	46	},
			{"id":	49	},
			{"id":	50	},
			{"id":	54	},
			{"id":	56	},
			{"id":	61	},
			{"id":	64	},
			{"id":	79	},
			{"id":	81	},
			{"id":	89	},
			{"id":	95	},
			{"id":	100	},
			{"id":	102	},
			{"id":	103	},
			{"id":	109	}
		],
		"Midlands": [
			{"id":	15	},
			{"id":	20	},
			{"id":	21	},
			{"id":	40	},
			{"id":	52	},
			{"id":	53	},
			{"id":	55	},
			{"id":	66	},
			{"id":	67	},
			{"id":	70	},
			{"id":	72	},
			{"id":	73	},
			{"id":	82	},
			{"id":	83	},
			{"id":	90	},
			{"id":	92	},
			{"id":	97	},
			{"id":	105	},
			{"id":	106	},
			{"id":	111	}
		],
		"North England": [
			{"id":	6	},
			{"id":	18	},
			{"id":	19	},
			{"id":	24	},
			{"id":	26	},
			{"id":	33	},
			{"id":	38	},
			{"id":	48	},
			{"id":	51	},
			{"id":	58	},
			{"id":	60	},
			{"id":	62	},
			{"id":	69	},
			{"id":	71	},
			{"id":	80	},
			{"id":	86	},
			{"id":	91	},
			{"id":	101	},
			{"id":	104	},
			{"id":	108	},
			{"id":	112	}
		],
		"Ireland": [
			{"id":	113	},
			{"id":	114	},
			{"id":	115	},
			{"id":	116	},
			{"id":	117	},
			{"id":	118	},
			{"id":	119	},
			{"id":	120	},
			{"id":	121	},
			{"id":	122	},
			{"id":	123	},
			{"id":	124	},
			{"id":	125	},
			{"id":	126	},
			{"id":	127	},
			{"id":	128	},
			{"id":	129	},
			{"id":	130	},
			{"id":	131	},
			{"id":	132	},
			{"id":	133	},
			{"id":	134	},
			{"id":	135	},
			{"id":	136	},
			{"id":	137	},
			{"id":	138	},
			{"id":	193 },
			{"id":	194	},
			{"id":	195	},
			{"id":	196	},
			{"id":	197	},
			{"id":	198	},
			{"id":	199	},
			{"id":	200	},
			{"id":	201	},
			{"id":	202	},
			{"id":	203	},
			{"id":	204	},
			{"id":	205	},
			{"id":	206	},
			{"id":	207	},
			{"id":	208	},
			{"id":	209	},
			{"id":	210	},
			{"id":	211	},
			{"id":	212	},
			{"id":	213	},
			{"id":	214	},
			{"id":	215	},
			{"id":	216	},
			{"id":	217	},
			{"id":	218	},
			{"id":	219	},
			{"id":	220	},
			{"id":	221	},
			{"id":	222	},
			{"id":	223	},
			{"id":	224	},
			{"id":	225	},
			{"id":	226	},
			{"id":	227	},
			{"id":	228	},
			{"id":	229	},
			{"id":	230	},
			{"id":	231	},
			{"id":	232	}
		],
		"Scotland": [
			{"id":	139	},
			{"id":	140	},
			{"id":	141	},
			{"id":	142	},
			{"id":	143	},
			{"id":	144	},
			{"id":	145	},
			{"id":	146	},
			{"id":	147	},
			{"id":	148	},
			{"id":	149	},
			{"id":	150	},
			{"id":	151	},
			{"id":	152	},
			{"id":	153	},
			{"id":	154	},
			{"id":	155	},
			{"id":	156	},
			{"id":	157	},
			{"id":	158	},
			{"id":	159	},
			{"id":	160	},
			{"id":	161	},
			{"id":	162	},
			{"id":	163	},
			{"id":	164	},
			{"id":	165	},
			{"id":	166	},
			{"id":	167	},
			{"id":	168	},
			{"id":	169	},
			{"id":	170	}
		],
		"Southeast": [
			{"id":	3	},
			{"id":	9	},
			{"id":	12	},
			{"id":	13	},
			{"id":	27	},
			{"id":	29	},
			{"id":	41	},
			{"id":	47	},
			{"id":	57	},
			{"id":	59	},
			{"id":	65	},
			{"id":	75	},
			{"id":	88	},
			{"id":	93	},
			{"id":	94	},
			{"id":	98	},
			{"id":	107	}
		],
		"Southwest": [
			{"id":	2	},
			{"id":	4	},
			{"id":	7	},
			{"id":	10	},
			{"id":	16	},
			{"id":	22	},
			{"id":	23	},
			{"id":	30	},
			{"id":	35	},
			{"id":	44	},
			{"id":	63	},
			{"id":	68	},
			{"id":	74	},
			{"id":	76	},
			{"id":	77	},
			{"id":	78	},
			{"id":	84	},
			{"id":	85	},
			{"id":	87	},
			{"id":	96	},
			{"id":	99	},
			{"id":	110	}
		],
		"Wales": [
			{"id":	171	},
			{"id":	172	},
			{"id":	173	},
			{"id":	174	},
			{"id":	175	},
			{"id":	176	},
			{"id":	177	},
			{"id":	178	},
			{"id":	179	},
			{"id":	180	},
			{"id":	181	},
			{"id":	182	},
			{"id":	183	},
			{"id":	184	},
			{"id":	185	},
			{"id":	186	},
			{"id":	187	},
			{"id":	188	},
			{"id":	189	},
			{"id":	190	},
			{"id":	191	},
			{"id":	192	}
		],
	};
	
	scale: any[];
	
	osmLayer: TileLayer;
	
	constructor(private speakerSrv: SpeakerService) {
		// this.initializeData();
		this.speakerSrv.statsChange.subscribe(stats => {
			this.stats = stats;
			this.update(stats);
		});
	}
	
	ngOnInit(): void {
		this.osmLayer = new TileLayer({
			source: new OSM(),
			visibility: false
		});
		
		let map1 = new Map({
			layers: [
				// basetile,
				this.osmLayer,
				new VectorLayer({
					source: new VectorSource({
						url: 'https://raw.githubusercontent.com/LoveenDyall/CASS/master/uk-ni.geojson',
						format: new GeoJSON({ featureProjection: 'EPSG:3857', dataProjection: 'EPSG:4326' })
					}),
					style: (feature) => {
						return this.styleFunc1(this, feature);
					}
				})
			],
			target: 'map1',
			view: new View({
				center: fromLonLat([-4, 54]),
				zoom: 5.3,
				projection: 'EPSG:3857'
			})
		});
		
		map1.on('click', (evt) => {
			let features = map1.getFeaturesAtPixel(evt.pixel);
			if (features && features.length > 0) {
				let wantedId = features[0].values_['ID_2'];
				for (let region of Object.keys(this.regionMappings)) {
					for (let id of this.regionMappings[region]) {
						if (id.id == wantedId) {
							this.speakerSrv.changeView('Concordance', event);
							this.speakerSrv.concordanceMapFilter.next({
								'corpus': 1994,
								'region': region
							});
							return;
						}
					}
				}
			}
		});
		
		map1.on('moveend', (evt) => {
			let newZoom = map1.getView().getZoom();
			if (newZoom > 8.0) {
				this.osmLayer.setVisible(true)
			} else {
				this.osmLayer.setVisible(false);
			}
		});
		
		let map2 = new Map({
			layers: [
				// basetile,
				this.osmLayer,
				new VectorLayer({
					source: new VectorSource({
						url: 'https://raw.githubusercontent.com/LoveenDyall/CASS/master/uk-ni.geojson',
						format: new GeoJSON({ featureProjection: 'EPSG:3857', dataProjection: 'EPSG:4326' })
					}),
					style: (feature) => {
						return this.styleFunc2(this, feature);
					}
				})
			],
			target: 'map2',
			view: new View({
				center: fromLonLat([-4, 54]),
				zoom: 5.3,
				projection: 'EPSG:3857'
			})
		});
		map2.on('click', (evt) => {
			let features = map2.getFeaturesAtPixel(evt.pixel);
			if (features && features.length > 0) {
				let wantedId = features[0].values_['ID_2'];
				for (let region of Object.keys(this.regionMappings)) {
					for (let id of this.regionMappings[region]) {
						if (id.id == wantedId) {
							this.speakerSrv.changeView('Concordance', event);
							this.speakerSrv.concordanceMapFilter.next({
								'corpus': 2014,
								'region': region
							});
							return;
						}
					}
				}
			}
		});
		map2.on('moveend', (evt) => {
			let newZoom = map1.getView().getZoom();
			if (newZoom > 8.0) {
				this.osmLayer.setVisible(true)
			} else {
				this.osmLayer.setVisible(false);
			}
		});
	}
	
	styleFunc1(self, feature: Feature) {
		for (let region of self.choropleth1994) {
			if (region.id == feature.values_['ID_2']) {
				return region.col;
			}
		}
	}
	
	styleFunc2(self, feature: Feature) {
		for (let region of self.choropleth2014) {
			if (region.id == feature.values_['ID_2']) {
				return region.col;
			}
		}
	}
	
	update(stats) {
		let data1994 = {};
		let data2014 = {};
		
		generateData(stats["1994"], data1994);
		generateData(stats["2014"], data2014);
		
		let regions1994 = [];
		let regions2014 = [];
		
		let min = data1994["London"];
		let max = data1994["London"];
		
		let frequency1994;
		let frequency2014;
		
		for (let region of Object.keys(this.regionMappings)) {
			frequency1994 = data1994[region];
			frequency2014 = data2014[region];
			
			if (data1994[region] < min)
				min = frequency1994;
			if (data2014[region] < min)
				min = frequency2014;
			if (data1994[region] > max)
				max = frequency1994;
			if (data2014[region] > max)
				max = frequency2014;
		}
		
		let colstop1 = 'rgba(105,130,231,';
		let colstop2 = 'rgba(247,126,151,';
		
		this.scale = [];
		
		let range = max - min;
		let ticks = 5;
		let tickD = range / ticks;
		
		for (let i = tickD; i <= range; i += tickD) {
			let ratio = i / range;
			let opc = ratio * 0.5 + 0.07;
			this.scale.push({
				v: i,
				c1: colstop1 + opc + ')',
				c2: colstop2 + opc + ')'
			})
		}
		
		for (let region of Object.keys(this.regionMappings)) {
			let freq94 = data1994[region];
			let freq14 = data2014[region];
			
			let ratio1 = (freq94 - min) / (max - min);
			let ratio2 = (freq14 - min) / (max - min);
			
			let style94 = new Style({
				fill: new Fill({
					color: colstop1 + (ratio1 * 0.5 + 0.07) + ')'
				}),
				stroke: new Stroke({
					color: 'rgba(0, 0, 0, 0.05)'
				})
			});
			let style14 = new Style({
				fill: new Fill({
					color: colstop2 + (ratio2 * 0.5 + 0.07) + ')'
				}),
				stroke: new Stroke({
					color: 'rgba(0, 0, 0, 0.05)'
				})
			});
			for (let i = 0; i < this.regionMappings[region].length; i++) {
				regions1994.push({"id": this.regionMappings[region][i].id, "col": style94});
				regions2014.push({"id": this.regionMappings[region][i].id, "col": style14});
			}
		}
		
		this.choropleth1994 = regions1994;
		this.choropleth2014 = regions2014;
		
		function generateData(corpusSpeakers, output) {
			let counts = {};
			if (corpusSpeakers) {
				for (let speaker of Object.keys(corpusSpeakers)) {
					if (output[corpusSpeakers[speaker]["area"]] != undefined) {
						counts[corpusSpeakers[speaker]["area"]] += 1;
						output[corpusSpeakers[speaker]["area"]] += corpusSpeakers[speaker]["relative"];
					} else {
						output[corpusSpeakers[speaker]["area"]] = corpusSpeakers[speaker]["relative"];
						counts[corpusSpeakers[speaker]["area"]] = 1;
					}
				}
				for (let area of Object.keys(output)) {
					output[area] = output[area] / counts[area];
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/map/map.component.ts